import client from './SharedConfig';

export const signup = ({body={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/register',
        data: body
    };
    return client.request(config )
};

export const activate = ({body={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/activate',
        data: body
    };
    return client.request(config )
};

export const login = ({body={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/login',
        data: body
    };
    return client.request(config )
};

export const changePass = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/newpass',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const buyElevator = ({body={}, header={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/elevator',
        data: body,
        headers: header
    };
    return client.request(config )
};

export const forgotPassword = ({body={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/changepass',
        data: body
    };
    return client.request(config )
};

export const resendKey = ({body={}} = {}) => {
    const config = {
        method: 'POST',
        url: 'user/resendkey',
        data: body
    };
    return client.request(config )
};

export const myInfo = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'user/info',
        headers: header
    };
    return client.request(config )
}

export const getAllMyAds = ({parameter={}, header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/dashboard/ads/list/',
        params: parameter,
        headers: header
    };
    return client.request(config )
};

export const getAllMyStores = ({parameter={}, header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/dashboard/stores/list/',
        params: parameter,
        headers: header
    };
    return client.request(config )
};

export const getAllMyFavourites = ({parameter={}, header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/dashboard/favourites/list/',
        params: parameter,
        headers: header
    };
    return client.request(config )
};

export const latestPrices = ({parameter={}, header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/latestPrice/list/',
        params: parameter,
        headers: header
    };
    return client.request(config )
};

export const myFavouriteJobIds = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/job/favourite/ids/',
        headers: header
    };
    return client.request(config )
}

export const myFavouriteAdIds = ({header={}} = {}) => {
    const config = {
        method: 'GET',
        url: 'advertisement/vehicle/favourite/ids/',
        headers: header
    };
    return client.request(config )
}